import React from 'react';
import usePartners from '~/view-data/use-partners';
import useAuth from '~/view-data/use-auth';
import _ from 'lodash';
import { MdDelete, MdEdit } from 'react-icons/md';
import { formats } from '~/helper';
import { Summary, TabContainer } from '~/views/partners/styles';
import DataTable from '~/components/datatable';
import { IconButton } from '~/components/button';
import ModalEditContract from '~/views/partners/modal-edit-contract';
import ModalIpList from '~/views/partners/modal-ip-list';

const TabContracts = ({ values, goToContract, handleRemoveContract }) => {
  const { actions } = usePartners();
  const { state: authState } = useAuth();

  // Verifica permissão de alteração (W) na Lista de Endereços IP/DDNS (A13)
  const canEditIps = React.useMemo(() => {
    const menu = authState && authState.menu;
    if (!menu) return false;
    // Busca recursiva por code === 'A13'
    function findA13(arr) {
      for (const item of arr) {
        if (item.code === 'A13') return item;
        if (item.children && Array.isArray(item.children)) {
          const found = findA13(item.children);
          if (found) return found;
        }
      }
      return null;
    }
    const ipMenu = Array.isArray(menu)
      ? findA13(menu)
      : null;
    if (!ipMenu || !ipMenu.perms) return false;
    return ipMenu.perms.includes('W');
  }, [authState]);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [selectedContract, setSelectedContract] = React.useState(null);
  const [isIpModalOpen, setIpModalOpen] = React.useState(false);
  const [ipList, setIpList] = React.useState([]); // Estado local para IPs
  const [selectedContractId, setSelectedContractId] = React.useState(null);
  const [selectedContractData, setSelectedContractData] = React.useState(null);
  const openIpModal = (contractId, ips = [], contractData = null) => {
    setSelectedContractId(contractId);
    setIpList(ips);
    setSelectedContractData(contractData);
    setIpModalOpen(true);
  };
  const closeIpModal = () => {
    setIpModalOpen(false);
    setSelectedContractId(null);
    setSelectedContractData(null);
  };
  const handleSaveIps = async (ips) => {
    setIpList(ips);
    setIpModalOpen(false);
    setSelectedContractId(null);
    setSelectedContractData(null);
    if (values.id) {
      await actions.load({ id: values.id }); // Recarrega o parceiro e contratos
    }
  };
  const handleOpenIpModal = (row) => {
    openIpModal(row.id, row.ips_list || [], row);
  };

  const openEditModal = (contract) => {
    console.log('Estado completo da tela:', values); // Loga o estado completo da tela
    const partnerData = {
      id: values.id,
      identity: values.identity,
      name: values.name
    };
    const contractData = {
      ...contract,
      partner: partnerData
    };
    console.log('Dados enviados para o modal:', contractData); // Loga os dados enviados para o modal
    setSelectedContract(contractData);
    setModalOpen(true);
  };

  const closeEditModal = () => {
    setModalOpen(false);
    setSelectedContract(null);
  };

  const columns = [
    {
      name: 'Id',
      selector: 'id',
      width: '70px'
    },
    {
      name: 'Grupo',
      selector: 'groupName'
    },
    {
      name: 'Nr. Contrato',
      selector: 'controlContractNumber'
    },
    {
      name: 'Inicia em',
      selector: 'startDate',
      width: '110px',
      format: row => formats.dateTimeZone(_.get(row, 'startDate'), 'dd/MM/yyyy')
    },
    {
      name: 'Nº Clientes',
      selector: 'services',
      right: true,
      width: '110px',
      format: row => formats.number(_.size(row.services))
    },
    {
      name: 'Ações',
      selector: 'services',
      right: true,
      width: '180px',
      cell: row => (
        <>
          {canEditIps && (
            <IconButton size={32} type="button" title="Cadastrar IPs" onClick={() => handleOpenIpModal(row)} style={{ color: 'black' }}>
              <span role="img" aria-label="ip" style={{ fontSize: 20, color: 'black' }}>🌐</span>
            </IconButton>
          )}
          <IconButton size={32} type="button" title="Editar" onClick={() => openEditModal(row)}>
            <MdEdit />
          </IconButton>
          <IconButton size={32} type="button" title="Remover" onClick={() => handleRemoveContract(row)}>
            <MdDelete />
          </IconButton>
        </>
      )
    }
  ];

  return (
    <>
      {/* Botão de cadastrar IPs agora está na coluna de ações por linha */}
      <TabContainer>
        <DataTable
          columns={columns}
          data={{ rows: values.contracts || [] }}
          noPagination={true}
          emptyText="Nenhum contrato de aditamento encontrado"
          keyField="id"
          onRowClicked={data => goToContract(data.id)}
          extraOptions={{
            ignoreRowClicked: false,
            selectableRowsHighlight: false,
            selectableRows: false
          }}
        />
      </TabContainer>
      <Summary>
        <label className="label">Quantidade: {_.size(values.contracts || [])}</label>
      </Summary>

      {isModalOpen && (
        <ModalEditContract
          isOpen={isModalOpen}
          onClose={closeEditModal}
          contractData={selectedContract}
          partners={values.partners || []}
        />
      )}

      {isIpModalOpen && (
        <ModalIpList
          open={isIpModalOpen}
          onClose={closeIpModal}
          onSave={handleSaveIps}
          initialIps={ipList}
          contractId={selectedContractId}
          contractData={selectedContractData}
        />
      )}
    </>
  );
};

export default TabContracts;
